import { localDateAndTime, hourFromTime } from "../../../services/time-service"

export const deliveryTaskViews = self => ({
  get taskCreatedAt() {
    return localDateAndTime(self.createdAt)
  },
})